{
  "errors": {
    "yourRoleDoesNotAllowThisAction": "Votre rôle ne vous permet pas de {action}",
    "yourRoleDoesNotAllowYouToPerformThisAction": "Votre rôle ne vous permet pas d’effectuer cette action",
    "mustHaveAtLeast8Characters": "Doit contenir au moins 8 caractères",
    "mustContainUpperCaseAndLowerCase": "Doit contenir des majuscules et des minuscules",
    "mustContainAtLeastOneLetter": "Doit contenir au moins une lettre",
    "mustContainAtLeastOneSpecialCharacter": "Doit contenir au moins un caractère spécial",
    "mustContainAtLeastOneNumber": "Doit contenir au moins un chiffre"
  },
  "descriptions": {
    "allPermissionsAndFullControlOverAllAccounts": "Tous les droits et un contrôle total sur tous les comptes.",
    "godRoleWithLessControl": "Rôle GOD avec moins de contrôle.",
    "allPermissionsAndFullControlOverTheOrganizationAccount": "Tous les droits et un contrôle total sur le compte de l’organisation.",
    "createEditDeleteAppointmentsWarehousesLoadTypesDocksAndUsersExceptOwners": "Créer/modifier/supprimer les rendez-vous, entrepôts, types de chargement, quais et utilisateurs (sauf les propriétaires).",
    "createEditCancelAppointments": "Créer/modifier/annuler des rendez-vous.",
    "editAppointmentStatusTagsAndSubscribers": "Modifier le statut du rendez-vous, les étiquettes et les abonnés.",
    "viewOnlyNoCreateOrEditActionsAllowed": "Lecture seule. Aucune action de création ou de modification autorisée.",
    "carrierAdministrator": "Administrateur du transporteur.",
    "carrierUser": "Utilisateur du transporteur",
    "baseUserAccount": "Compte utilisateur de base.",
    "warehouseDriverHasLimitedAccessToTheApplication": "Conducteur de l'entrepôt, a un accès limité à l'application."
  }
}
